import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../authorization/AuthorizationConfig";
import { InteractionStatus } from "@azure/msal-browser";
import {
  pickPreferredAccount,
  resetLoginRedirectGuard,
  tryBeginLoginRedirect,
} from "../../authorization/msalGuards";

/**
 * Only starts loginRedirect when MSAL is idle and the user is not signed in.
 * Uses instance.getAllAccounts() because React context can briefly lag behind the cache.
 * With multiple cached accounts (account switching), we never use accounts[0] alone — see pickPreferredAccount.
 */
const LoginPage = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      resetLoginRedirectGuard();
      return;
    }
    if (
      inProgress === InteractionStatus.Startup ||
      inProgress === InteractionStatus.HandleRedirect
    ) {
      return;
    }
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    const cached = instance.getAllAccounts();
    if (cached.length > 0) {
      const next =
        cached.length === 1 ? cached[0] : pickPreferredAccount(cached);
      instance.setActiveAccount(next);
      resetLoginRedirectGuard();
      return;
    }

    if (!tryBeginLoginRedirect()) return;
    void instance
      .loginRedirect({
        ...loginRequest,
        prompt: "select_account",
      })
      .catch((err) => {
        console.error("loginRedirect failed:", err);
        resetLoginRedirectGuard();
      });
  }, [instance, inProgress, isAuthenticated]);

  return <div>Logging you in…</div>;
};

export default LoginPage;
